import Debtor from '@/views/debtor/Add.vue'

const router = {
    path: '/debtors/add',
    name: 'DebtorAdd',
    component: Debtor,
    meta: {
        title: 'Add Debtor'
    }
  };

export default router
